import { useCallback, useEffect, useState } from "react";

const useBannerKountriesHeight = (): number => {
  const [height, setHeight] = useState<number>(0);

  const getBannerKountriesHeight = useCallback((bannerKountries: HTMLElement) => {
    const bannerKountriesHeight = bannerKountries.offsetHeight;
    setHeight(bannerKountriesHeight);
  }, []);

  useEffect(() => {
    const bannerKountries = document.getElementById("BannerKountriesComponent");
    if (bannerKountries) {
      bannerKountries.addEventListener("DOMNodeInserted", () =>
        getBannerKountriesHeight(bannerKountries)
      );
      getBannerKountriesHeight(bannerKountries);
    }
  }, []);

  return height;
};

export default useBannerKountriesHeight;
